<template lang="pug">
  .b2b-page-newuser
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('users.createuser.newuser.title') }}
      ods-form(
        ref='newUserForm',
        :rules='rulesNewUserForm',
        :model='newUserForm',
        label-width='14rem',
        label-position='top',
        size='mini')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("users.createuser.newuser.username")',
              prop='username')
              ods-input(v-model='newUserForm.username')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("users.createuser.newuser.email")',
              prop='email')
              ods-input( v-model.trim='newUserForm.email')
    ods-row.form-actions
      ods-col(:span='24')
        ods-button(
          type='primary',
          size='large'
          @click='goDataUser("newUserForm")')
          | {{ $t('buttons.btnNext') }}
        ods-button(
          ref='buttonClear',
          type='neutral',
          size='large'
          @click='goClear')
          | {{ $t('buttons.btnClear') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-newuser',
  mixins: [Utils],

  data () {
    return {
      newUserForm: {}
    }
  },

  props: {
    duplicateUserData: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters([
      'newUserSession',
      'modifyUserSession'
    ]),

    rulesNewUserForm () {
      const validateContact = (rule, value, callback) => {
        if (this.checkCorrectEmail(value)) {
          callback()
        } else {
          callback(new Error(this.$t('profile.contact.rules_form.email_format')))
        }
      }
      return {
        email: [
          {
            max: 64,
            message: this.$t('validations.maxlenght', { maxlenght: 64 }),
            trigger: 'change'
          },
          {
            required: true,
            message: this.$t('validations.required', {
              field: this.$t('users.createuser.newuser.email')
            }),
            trigger: 'change'
          },
          {
            validator: validateContact,
            trigger: 'change'
          }
        ],
        username: [
          {
            max: 64,
            message: this.$t('validations.maxlenght', { maxlenght: 64 }),
            trigger: 'change'
          },
          {
            min: 6,
            message: this.$t('validations.minlenght', { minlenght: 6 }),
            trigger: 'change'
          },
          {
            required: true,
            message: this.$t('validations.required', {
              field: this.$t('users.createuser.newuser.username')
            }),
            trigger: 'change'
          }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'validateUser',
      'newUserSessionState',
      'modifyUserSessionState'
    ]),

    goDataUser (formName) {
      let usuario = {}
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            usuario = await this.validateUser({
              username: this.newUserForm.username.trim(),
              email: this.newUserForm.email.trim()
            })

            // Usuario existente en BD Seteamos campos en objetos modifyUserSesion
            this.modifyUserSession.username = this.newUserForm.username.trim()
            this.modifyUserSession.email = this.newUserForm.email.trim()
            this.modifyUserSession.usuario = usuario
            // Si es modificación limpiamos objeto de nuevo usuario
            this.resetNewUser()
            // - Redirigimos
            router.push({
              name: 'cif-party'
            })
          } catch (error) {
            console.log('goDataUser CATCH: ', error)
            if (error.status === 404) {
              // Usuario no existente en BD
              // Si es nuevo usuario limpiamos objeto de modificación
              if (this.duplicateUserData !== undefined) {
                this.duplicateUserData.username = this.newUserForm.username.trim() // eslint-disable-line
                this.duplicateUserData.email = this.newUserForm.email.trim() // eslint-disable-line
              }
              this.newUserSession.username = this.newUserForm.username.trim()
              this.newUserSession.email = this.newUserForm.email.trim()
              this.resetModifyUser()
              // Emitimos el evento
              this.$emit('update', 1)
            }
            if (error.status !== 404) {
              this.showNotificationError(error)
            }
          }
        } else {
          return false
        }
      })
    },

    goClear () {
      this.$refs.buttonClear.$el.blur()
      this.newUserForm = {
        username: '',
        email: ''
      }
    },

    async resetNewUser () {
      await this.newUserSessionState({
        username: null,
        email: null,
        name: null,
        firstSurname: null,
        secondSurname: null,
        taxIdentificationNumber: null,
        partyTaxIdentificationNumber: null,
        userentities: [],
        rolesAuthoritiesUser: {
          roles: [],
          authorities: [],
          projectId: null
        }
      })
    },

    async resetModifyUser () {
      await this.modifyUserSessionState({
        username: null,
        email: null,
        name: null,
        firstSurname: null,
        secondSurname: null,
        taxIdentificationNumber: null,
        partyTaxIdentificationNumber: null,
        userentities: [],
        rolesAuthoritiesUser: {
          roles: [],
          authorities: [],
          projectId: null
        }
      })
    }

  },

  async created () {
    console.log('B2bNewUSer', this.newUserSession)
    // console.log('B2bNewUSer ' + JSON.stringify(this.duplicateUserData))
    if (this.newUserSession.username !== null && this.newUserSession.username.length > 0) {
      this.newUserForm = this.newUserSession
    } else if (this.modifyUserSession.username !== null && this.modifyUserSession.username.length > 0) {
      this.newUserForm = this.modifyUserSession
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-newuser {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }

      .subtitle{
        margin-top: 40px;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
